
import React, { Component } from 'react'
import Paper from 'material-ui/Paper';
import ManageServiceButtonsComponent from '../../../../components/services/ManageServiceButtonsComponent'

import { services as ROLES_CONFIG } from '../../../../config/roles';

import Page403 from 'routes/403/'

export default class ManageServices extends Component {

  constructor(props) {
    super(props);
    this.state = {
      role: this.props.authenticated ? this.props.authenticated.role : null
    }
  }

  render() {
    return (
      <div id="content">
        <div className="row">
          {
            ROLES_CONFIG.service_assign_button.indexOf(this.state.role) != -1 ?
              <Paper className="col-sm-11 col-11 ml-2vw h-100 mt-1vw p-0 customShadow" zDepth={3}>
                <ManageServiceButtonsComponent />
              </Paper> 
            : <Page403 />
          }
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./routes/app/routes/services/ManageServiceButtons.js